/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import React, {useState, useEffect} from "react";
import SafeLink from "components/commons/SafeLink";
import Head from "next/head";

import styled, {createGlobalStyle} from "styled-components";

import {
  SegmentAnalytics,
  NewFooter
} from "components";
import {WealthyEnv} from "helpers";
import {
  LogoWrapper,
  LogoImage
} from "components/StaticPages/Common";

import GlobalStyle from "static/next/css/PartnerGlobalStyle";
import LearnGlobalStyle from "static/next/css/LearnGlobalStyle";

const PageStyle = createGlobalStyle`
  @font-face {
    font-family: "Poppins-Bold";
    src: url(${WealthyEnv.CDN_URL}/wealthy-fonts/Poppins-Bold.woff) format("woff")
  }
  @font-face {
    font-family: "Poppins-Regular";
    src: url(${WealthyEnv.CDN_URL}/wealthy-fonts/Poppins-Regular.woff) format("woff")
  }

  body {
    line-height: 1.6;
    overflow-x:hidden;
    font-family: 'Poppins-Regular', sans-serif;
  }

  a {
    color: #5578eb;
    text-decoration: none;
  }
`;

const wealthyLogoUrl = `${WealthyEnv.CDN_URL}/wealth-managers/wealthy-buildwealth-logo.svg`;
const supportIcon = `${WealthyEnv.CDN_URL}/wealth-managers/support-headphone-icon.png`;

const PartnerSupport = () => {
  const [loginUrl, setLoginUrl] = useState(WealthyEnv.BUILDWEALTH_APP_URL);

  useEffect(() => {
    const isMobileView = window.matchMedia("(max-width: 768px)").matches;

    if (isMobileView) {
      setLoginUrl(WealthyEnv.PARNTER_APP_DEEPLINK);
    }
  }, []);

  return (
    <>
      <Head>
        <title>Wealthy Partner Support | Wealthy.in</title>
        <meta content="If you are facing issues with the partner app or web platforms, please read on to try some common solutions or contact us with the issue you are facing." name="description" />
        <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
        <link as="style" href="static/next/css/header-footer.css" rel="preload" />
        <link href={`${WealthyEnv.URL}/partner-support`} rel="canonical" />
        <link href="static/next/css/header-footer.css" rel="stylesheet" />
      </Head>
      <SegmentAnalytics />
      <PageStyle />
      <GlobalStyle />
      <LearnGlobalStyle />
      <Wrapper>
        <Header>
          <LogoWrapper>
            <SafeLink href={WealthyEnv.URL}>
              <LogoImage
                alt="Wealthy Logo"
                src={`${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`}
              />
            </SafeLink>
          </LogoWrapper>
        </Header>
        <SupportContent>
          <ContentHeader>
            <Title>
             Stock Account Closure
            </Title>
            {/* <Icon
              alt="support icon"
              src={supportIcon}
            /> */}
          </ContentHeader>
          <SubHeading>
          We are in dismay to know that you wish to deactivate your account with us, however you can give us one more chance to improve on our service and grow together.
          </SubHeading>
          <SubHeadingTwo>
           If you still wish to go ahead with deactivation do not forget to do following important steps:
          </SubHeadingTwo>
          <SubHeadingTwo>
            If you currently hold any holdings in your account, you need to
          </SubHeadingTwo>
          <List>
            <Item>
    Transfer shares to your another demat account by providing demat account number in the closure form (Name and remaining details to be 100% match) or sell them before requesting for account closure
            </Item>
          </List>
          <Text>
           Your fund balance should be clearoff, you can do it by visiting APP/website under the “Accounts” section.
          </Text>
          <SubHeadingTwo>
            Once the above steps are done proceed further do the following:
          </SubHeadingTwo>
          <Text>For Offline Process</Text>
          <List>
            <Item>
               Download the account closure form
            </Item>
            <Item>
               Download
            </Item>
            <Item>
               Duly fill it with the details
            </Item>
            <Item>
               Sign digitally (Refer steps below to understand how it can be done)
            </Item>
            <Item>
              Upload signed Document
            </Item>
          </List>
          <Text>For Online Process</Text>
          <List>
            <Item>
              Please login to your account via - App - <SafeLink
                className="download-app-link"
                href={WealthyEnv.PLAY_STORE_DOWNLOAD_LINK}
                rel="noopener noreferrer"
                target="_blank"
                aria-label="Download Wealthy Android App"
              >Andriod</SafeLink>/
              <SafeLink
                className="download-app-link"
                href={WealthyEnv.APP_STORE_DOWNLOAD_LINK}
                rel="noopener noreferrer"
                target="_blank"
                aria-label="Download Wealthy iOS App"
              >IOS</SafeLink>
            </Item>
          </List>
          <Text>
           Details should match with our records otherwise it will be rejected.
          </Text>
          <SubHeadingTwo>
            The process of digitally e-signing is as below -
          </SubHeadingTwo>
          <Text>
             Fill up the closure form
          </Text>
          <OList>
            <OListItem>
              <SafeLink
                href="https://www.digilocker.gov.in/"
                rel="noopener noreferrer"
                target="_blank"
                aria-label="Login to DigiLocker"
              >Login to diglilocker.gov.in.</SafeLink>
            </OListItem>
            <OListItem>
              Click on Drive.
            </OListItem>
            <OListItem>
              Click on Documents and click on UPLOAD FILE.
            </OListItem>
            <OListItem>
              Upload a document and click on Sign.
            </OListItem>
            <OListItem>
              Upload a document and click on Sign.
            </OListItem>
            <OListItem>
              Enter the Aadhar number and click on Get OTP.
            </OListItem>
            <OListItem>
             Enter OTP and tick on consent.
            </OListItem>
          </OList>
          <ImageConatiner>
            <Image src="https://i.wlycdn.com/articles/account-closure-.gif" 
                   alt="Steps to digitally sign account closure form"
            />
          </ImageConatiner>
          <Text>Send the document via mail to  <SafeLink href="customer.support@wealthy.in" aria-label="Email customer support">customer.support@wealthy.in</SafeLink>
          </Text>
        </SupportContent>
        <NewFooter />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  overflow-y: auto;
`;

const Header = styled.header`
  width: 100%;
  border-bottom: 1px solid rgba(0,0,0,.1);
`;

const SupportContent = styled.div`
  width: 80%;
  padding: 2rem 0;
  max-width: 860px;
  margin: 0 auto;
  font-size: 16px;
  color: black;
  line-height: 1.6;

 ul {
    margin-bottom: 2.5rem;
  }
`;

const ContentHeader = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 38px;
  line-height: 1;
`;

const Icon = styled.img`
  margin-left: 16px;
  height: 30px;
`;

const SubHeading = styled.h2`
  font-size: 18px;
  font-weight: 300;
  padding: 3rem 0rem;
`;

const SubHeadingTwo = styled.h2`
  font-size: 18px;
  font-weight: 300;
  padding: 1rem 0rem;
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: 300;
`;

const List = styled.ul`
  font-size: 18px;
  font-weight: 300;
  list-style-type: disc;
  padding-left: 20px;
`;

const Item = styled.li`
  margin-bottom: 0.5rem;
  margin-left: 1rem;
`;

const OList = styled.ol`
  font-size: 18px;
  font-weight: 300;
  padding-left: 20px;

  a{
    font-size: 18px;
    font-weight: 300;
    padding-left: 5px;
    text-decoration: none;
  }
`;

const OListItem = styled.li`
  margin-bottom: 0.5rem;
  margin-left: 3rem;
`;

const Image = styled.img`
  margin: 1rem auto;
  width: 100%;
`;


const ImageConatiner = styled.div``;

export default PartnerSupport;
